import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29edf503"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29edf503')) {
      api.createRecord('29edf503', component.options)
    } else {
      api.reload('29edf503', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=29edf503", function () {
      api.rerender('29edf503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/give-away/index.vue"
export default component.exports